/**
 * Created by lihanying on 2017/7/6.
 */

export const GETCLUBSHIFTLIST = 'GETCLUBSHIFTLIST'
export const GETPERIOD = 'GETPERIOD'



// WEBPACK FOOTER //
// ./src/containers/ClubShift/constants.js